import { render, staticRenderFns } from "./branding.vue?vue&type=template&id=40449ee4&scoped=true"
import script from "./branding.vue?vue&type=script&lang=js"
export * from "./branding.vue?vue&type=script&lang=js"
import style0 from "./branding.vue?vue&type=style&index=0&id=40449ee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40449ee4",
  null
  
)

export default component.exports